import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumSmsStatus implements BaseEnumType {
  private static allValues: EnumSmsStatus[] = []; // make sure this is top-most
  
  public static unknown = new EnumSmsStatus(0, "Unknown", "enum_sms_status_unknown");
  public static notSent = new EnumSmsStatus(1, "NotSent", "enum_sms_status_not_sent");
  public static sent = new EnumSmsStatus(2, "Sent", "enum_sms_status_sent");
  public static delivered = new EnumSmsStatus(3, "Delivered", "enum_sms_status_delivered");
  public static failed = new EnumSmsStatus(4, "Failed", "enum_sms_status_failed");
  public static unconfirmed = new EnumSmsStatus(5, "Unconfirmed", "enum_sms_status_unconfirmed");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumSmsStatus.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isUnknown() { return this === EnumSmsStatus.unknown; }
  public isNotSent() { return this === EnumSmsStatus.notSent; }
  public isSent() { return this === EnumSmsStatus.sent; }
  public isDelivered() { return this === EnumSmsStatus.delivered; }
  public isFailed() { return this === EnumSmsStatus.failed; }
  public isUnconfirmed() { return this === EnumSmsStatus.unconfirmed; }

  public static getValues(): readonly EnumSmsStatus[] {
    return EnumSmsStatus.allValues;
  }

  public static getValuesExcept0(): readonly EnumSmsStatus[] {
    return EnumSmsStatus.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumSmsStatus {
    const found = EnumSmsStatus.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumSmsStatus - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumSmsStatus): EnumSmsStatus {
    const found = name ? EnumSmsStatus.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumSmsStatus - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumSmsStatus>): boolean {
    return this.key === other?.key;
  }
}